import React from 'react';
import { Box, Typography, makeStyles, Button } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const useStyles = makeStyles(theme => ({
  card: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    minHeight: 44,
  },
  cardTitle: {
    color: theme.palette.text.primary,
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: '0.24px',
  },
  cardContent: {
    flex: 1,
    padding: theme.spacing(1.75),
    display: 'flex',
    flexDirection: 'column',
  },
  actionButton: {
    color: theme.palette.warning.main,
    fontSize: 11,
    fontWeight: 500,
    textTransform: 'none',
    padding: 0,
    minWidth: 'auto',
    '&:hover': {
      backgroundColor: 'transparent',
      opacity: 0.8,
    },
  },
  actionIcon: {
    fontSize: 11,
    marginLeft: 4,
  },
}));

type HomeCardProps = {
  title: string;
  actionLabel?: string;
  actionHref?: string;
  onAction?: () => void;
  headerContent?: React.ReactNode;
  children: React.ReactNode;
  noPadding?: boolean;
  fitContent?: boolean;
};

export const HomeCard = ({
  title,
  actionLabel,
  actionHref,
  onAction,
  headerContent,
  children,
  noPadding,
  fitContent,
}: HomeCardProps) => {
  const classes = useStyles();

  const handleAction = () => {
    if (onAction) {
      onAction();
    } else if (actionHref) {
      window.location.href = actionHref;
    }
  };

  return (
    <Box
      className={classes.card}
      style={fitContent ? { height: 'auto', overflow: 'visible' } : undefined}
    >
      <Box className={classes.cardHeader}>
        <Typography className={classes.cardTitle}>{title}</Typography>
        <Box display="flex" alignItems="center" style={{ gap: 8 }}>
          {headerContent}
          {actionLabel && (
            <Button
              className={classes.actionButton}
              onClick={handleAction}
              endIcon={<ArrowForwardIcon className={classes.actionIcon} />}
            >
              {actionLabel}
            </Button>
          )}
        </Box>
      </Box>
      <Box
        className={classes.cardContent}
        style={{
          ...(noPadding ? { padding: 0 } : {}),
          ...(fitContent ? { flex: 'none' } : {}),
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
